<fgb-banner [pageTitle]="'challenges.page.title'"></fgb-banner>

<fgb-page-header [pageTitle]="'challenges.page.title'" [backButtonLink]="'/'" />

<div class="container pb-lg-2 mt-30">
  <fgb-upgrade-banner></fgb-upgrade-banner>
  <fgbcl-badge-achieved />
</div>

<fgbcl-scorecard-list-view [icon]="'chevron_right'" [showPlaceholder]="true" />
